import PropTypes from 'prop-types';

import {
  Box,
  Stack,
  Dialog,
  Avatar,
  Typography,
  IconButton,
  DialogTitle,
  DialogContent,
} from '@mui/material';

import { fDateTime } from 'src/utils/format-time';

import { Iconify } from 'src/components/iconify';

import { getIconConfig } from './icon-config';
import { renderMessageWithLinks } from './render-message-with-links';

// ----------------------------------------------------------------------

export function NotificationDetailDialog({ open, onClose, notification }) {
  if (!notification) return null;
  const { type, title, message, createdAt } = notification;

  const config = getIconConfig(notification.type);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h6">Notification Detail</Typography>
          <IconButton onClick={onClose} size="small">
            <Iconify icon="mingcute:close-line" />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent>
        <Stack spacing={3}>
          {/* Icon and Title */}
          <Stack direction="row" spacing={2} alignItems="center">
            <Avatar
              sx={{
                width: 56,
                height: 56,
                color: config.color,
                bgcolor: config.bgcolor,
              }}
            >
              <Iconify icon={config.icon} width={28} />
            </Avatar>
            <Box>
              <Typography variant="h6">{title}</Typography>
              <Typography variant="caption" color="text.disabled">
                {fDateTime(createdAt)}
              </Typography>
            </Box>
          </Stack>

          {/* Message */}
          <Box sx={{ mb: 4, maxHeight: 400, overflow: 'auto' }}>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              Message
            </Typography>
            <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
              {renderMessageWithLinks(message, { onLinkClick: onClose })}
            </Typography>
          </Box>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

NotificationDetailDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  notification: PropTypes.shape({
    type: PropTypes.oneOf(['Info', 'Success', 'Warning', 'Error']),
    title: PropTypes.string,
    message: PropTypes.string,
    createdAt: PropTypes.string,
    isRead: PropTypes.bool,
  }),
};
